import { useReducer } from "react";

interface MirrorScreenState {
  isVisible: boolean;
  recentEMRData: any;
  membershipData: any[];
  pitchingData: any[];
  hasAutoOpenedForHighCarePet: boolean;
}

type MirrorScreenAction =
  | { type: "SET_VISIBLE"; payload: boolean }
  | { type: "SET_RECENT_EMR_DATA"; payload: any }
  | { type: "SET_MEMBERSHIP_DATA"; payload: any[] }
  | { type: "SET_PITCHING_DATA"; payload: any[] }
  | { type: "SET_AUTO_OPENED_FOR_HIGH_CARE_PET"; payload: boolean };

const initialMirrorScreenState: MirrorScreenState = {
  isVisible: false,
  recentEMRData: null,
  membershipData: [],
  pitchingData: [],
  hasAutoOpenedForHighCarePet: false,
};

function mirrorScreenReducer(state: MirrorScreenState, action: MirrorScreenAction): MirrorScreenState {
  switch (action.type) {
    case "SET_VISIBLE":
      return { ...state, isVisible: action.payload };
    case "SET_RECENT_EMR_DATA":
      return { ...state, recentEMRData: action.payload };
    case "SET_MEMBERSHIP_DATA":
      return { ...state, membershipData: action.payload };
    case "SET_PITCHING_DATA":
      return { ...state, pitchingData: action.payload };
    case "SET_AUTO_OPENED_FOR_HIGH_CARE_PET":
      return { ...state, hasAutoOpenedForHighCarePet: action.payload };
    default:
      return state;
  }
}

// Groups the mirror-screen flow (visibility, the recent EMR/membership data it renders,
// and the one-time auto-open flag for high-care pets).
export const useMirrorScreenState = () => {
  const [state, dispatch] = useReducer(mirrorScreenReducer, initialMirrorScreenState);

  return {
    isMirrorActionVisible: state.isVisible,
    setIsMirrorActionVisible: (payload: boolean) => dispatch({ type: "SET_VISIBLE", payload }),
    recentEMRData: state.recentEMRData,
    setRecentEMRData: (payload: any) => dispatch({ type: "SET_RECENT_EMR_DATA", payload }),
    membershipData: state.membershipData,
    setMembershipData: (payload: any[]) => dispatch({ type: "SET_MEMBERSHIP_DATA", payload }),
    pitchingData: state.pitchingData,
    setPitchingData: (payload: any[]) => dispatch({ type: "SET_PITCHING_DATA", payload }),
    initialRender: state.hasAutoOpenedForHighCarePet,
    setInitialRender: (payload: boolean) => dispatch({ type: "SET_AUTO_OPENED_FOR_HIGH_CARE_PET", payload }),
  };
};
